import { Catalogos } from "../services/Catalogos";

export class Helper {
    
	public static getFileNameExt(name:string, ext:string):string {
        const now:Date = new Date();
        return name + "_" + now.getFullYear() + '_' + now.getMonth() + '_' + now.getDate() + '_' + now.getHours() + '_' + now.getMinutes() + '_'+ now.getSeconds() + "." + ext ;
    }

	public static getBimestre(fecha:Date):string {
		if( fecha ) {
			let label = fecha.getFullYear() + ' Bimestre ';
			if( fecha.getMonth() < 2 ) {
				label+= + '1'
			} else if( fecha.getMonth() < 4 ) {
				label+= + '2'
			} else if( fecha.getMonth() < 6 ) {
				label+= + '3'
			} else if( fecha.getMonth() < 8 ) {
				label+= + '4'
			} else if( fecha.getMonth() < 10 ) {
				label+= + '5'
			} else if( fecha.getMonth() < 12 ) {
				label+= + '6'
			}
			return label
		}
		return ''
	}


	/**
	 * Retorna una cadena con los valores del periodo seleccionado en el calendario
	 *  {isValid:boolean, aIni:string, mIni:string, aFin:string, mFin:string}
	 */
	public static getPeriodoTxt( propsCalendar : {isValid:boolean, aIni:string, mIni:string, aFin:string, mFin:string}) : string {
		//calendarRef.current!["childNodes"][0]["value"]
		
		
		
		
		/*
		let periodo:string = 'per=' + elementos.periodo_anio_inicio + "," + elementos.periodo_mes_inicio + "," +
                             elementos.periodo_anio_fin + "," + elementos.periodo_mes_fin;*/

		let periodo:string = 'per=' + propsCalendar.aIni + "," + propsCalendar.mIni + "," + propsCalendar.aFin + "," + propsCalendar.mFin;
		
		
		return periodo;
	}
}